<template>
  <div class="insight-panel" :class="openModifier">
    <div class="insight-panel__wrap">
      <slot></slot>
    </div>
    <div class="insight-panel__bottom" v-if="showBottom">
      <span @click="onClick" class="insight-panel__link" :class="moreModifier">{{ text }}</span>
    </div>
  </div>
</template>
<script src="./insight-panel.js"></script>
<style src="./insight-panel.scss" lang="scss"></style>
